import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import { initTracking } from './lib/tracking'

// Init theme from localStorage before React mounts (no flash)
const savedTheme = localStorage.getItem('daien-theme') || 'light';
document.documentElement.dataset.theme = savedTheme;

// Init tracking pixels (Meta Pixel + GTM) - no-op if env vars empty
initTracking();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
